import { LanguageCode } from '@senet-uiverse/i18n';

import { IDocumentVersion } from '../types';

export const getDocumentTranslation = (
  document: IDocumentVersion,
  currentLanguage: LanguageCode,
  orgLanguage = LanguageCode.en,
) => {
  const translations = document.translations || [];
  const langTranslation = translations.find((item) => item.language === currentLanguage);

  if (langTranslation) {
    return langTranslation;
  }

  const orgTranslation = translations.find((item) => item.language === orgLanguage);

  if (orgTranslation) {
    return orgTranslation;
  }

  const defaultTranslation = translations.find((item) => item.language === LanguageCode.en);

  if (defaultTranslation) {
    return defaultTranslation;
  }

  return translations.find((translation) => !!translation.file)!;
};
